var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ready)?_c('VideoComp',{ref:"video",attrs:{"x":_vm.$px,"y":_vm.$py,"src":_vm.video,"scale":1}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }